// src/Data/Faqs.js

const featuredFaqs = [
  {
    question: "Who should use our tech services?",
    answer: "Startups, SMEs, and large enterprises looking for high-quality web, app, cloud, and Data Analytics solutions tailored to their business goals."
  },
  {
    question: "What services do you offer?",
    answer: "We specialize in web development, mobile app development, cloud infrastructure setup, and DevOps automation to streamline your software lifecycle."
  }
];

const allFaqs = [
  ...featuredFaqs,
  {
    question: "What is the MERN stack and why do you use it?",
    answer:"The MERN stack is a collection of four powerful technologies: MongoDB, Express.js, React, and Node.js. We use it because it's a unified, JavaScript-based stack that allows us to build fast, scalable, and modern web applications with a single language for both the front-end and back-end. This results in more efficient development and a more robust final product."
  },
  {
    question:"How long does it take to build a custom website or web application?",
    answer:"The timeline for a project varies depending on its complexity, features, and your specific requirements. A simple website might take a few weeks, while a complex e-commerce platform or custom application could take several months. We will provide a detailed project timeline after our initial discovery and planning phase."
  },
  {
    question:"Do you offer ongoing maintenance and support after the project is complete?",
    answer:"Yes, we do. We offer a variety of maintenance and support packages to ensure your website or application remains secure, up-to-date, and performs optimally. Our services include security patches, bug fixes, performance monitoring, and content updates."
  },
  {
    question:"Can you help me migrate my existing website to a new platform or CMS?",
    answer:"Absolutely. We specialize in website migration and CMS upgrades. Whether you're moving from an older platform to a modern CMS like WordPress or want to switch to a more powerful headless CMS, we ensure a seamless transition with no data loss and minimal disruption to your online presence."
  },
  {
    question:"What is the difference between SEO and PPC?",
    answer:"SEO (Search Engine Optimization) focuses on improving your website's organic (unpaid) ranking in search results. It's a long-term strategy that builds credibility and drives sustainable traffic. PPC (Pay-Per-Click), on the other hand, involves paying for ad placements on search engines and social media platforms to drive immediate, targeted traffic. We recommend a combination of both for the best results."
  },
  {
    question:"How much do your services cost?",
    answer:"Our pricing is based on the scope and complexity of your project. We provide a custom quote for each client after a detailed consultation to understand your goals, requirements, and budget. We believe in full transparency and will provide a clear breakdown of all costs."
  },
  {
    question:"Can you work with our existing CMS, like WordPress or Shopify?",
    answer:"Yes. Our expertise extends to the most popular Content Management Systems. We can develop custom themes, build bespoke plugins, and provide comprehensive maintenance and optimization for your existing WordPress, Shopify, or other CMS-powered sites."
  },
  {
    question:"How do you measure the success of your digital marketing campaigns?",
    answer:"We are a data-driven agency. We track key performance indicators (KPIs) such as website traffic, lead generation, conversion rates, and Return on Ad Spend (ROAS). We provide regular, easy-to-understand reports and dashboards so you can see the direct impact of our work on your bottom line."
  },
  {
    question:"What if I have a limited budget?",
    answer:"We work with clients of all sizes and budgets. During our initial consultation, we can help you prioritize your needs and create a phased plan that allows you to start with the most impactful services and scale up as your business grows."
  },
  {
    question:"How do we get started?",
    answer:"Getting started is easy! Simply contact us through our website or give us a call to schedule a free consultation. We'll discuss your business goals, a project brief, and how we can help you achieve them."
  },
  {
    question: "Do you provide end-to-end web development?",
    answer: "Yes, we handle everything from UI/UX design and frontend/backend development to deployment and maintenance."
  },
  {
    question: "What cloud platforms do you work with?",
    answer: "We work with AWS, Microsoft Azure, and Google Cloud to deliver scalable and secure cloud solutions."
  },
  {
    question: "Can you help us implement DevOps?",
    answer: "Absolutely. We offer CI/CD pipeline setup, infrastructure as code, monitoring, and automation to streamline your development process."
  },
  {
    question: "Do you offer support after project delivery?",
    answer: "Yes, we provide ongoing maintenance, performance optimization, and support to ensure your product runs smoothly post-launch."
  }
];


export default allFaqs;
